/**
 * Configuration Firebase
 */
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

/**
 * Configuration de l'API VTO (FastAPI)
 */
export const API_CONFIG = {
  // URL de votre backend VTO
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'https://iframe-vto-dev-965958056387.europe-west1.run.app',

  // Clé API si nécessaire pour l'authentification
  API_KEY: process.env.REACT_APP_API_KEY || '',

  // Timeout pour les requêtes API (en millisecondes)
  TIMEOUT: 120000, // 120 secondes (génération VTO peut prendre du temps)

  // Endpoints VTO
  ENDPOINTS: {
    VTO_WITH_AVATAR: '/vto/with-avatar',
    VTO_WITH_SELFIE: '/vto/with-selfie',
    HEALTH: '/health',
    // Anciens endpoints (à supprimer si non utilisés)
    USER_PROFILE: '/user/profile',
    SIZE_RECOMMENDATION: '/size-recommendation',
  },
};

/**
 * Configuration de la caméra
 */
export const CAMERA_CONFIG = {
  // Qualité de l'image JPEG (0-1)
  JPEG_QUALITY: 0.8,

  // Résolution idéale de la caméra
  VIDEO_WIDTH: 1920,
  VIDEO_HEIGHT: 1080,
};

/**
 * Configuration de la Gateway (FastAPI - orchestrateur entre les microservices)
 * Gère la recommandation de taille et le VTO via les services internes
 */
export const GATEWAY_CONFIG = {
  BASE_URL: process.env.REACT_APP_MIRROR_API_URL || 'http://localhost:9002',
  ENDPOINTS: {
    SIZE_RECO_ANONYMOUS: '/api/size-recommendation/anonymous',
    SIZE_RECO_SHOPPER: '/api/size-recommendation/shopper',
    VTO_ANONYMOUS: '/api/generate-vto/moodboard-anonymous',
    VTO_ANONYMOUS_AVATAR: '/api/generate-vto/moodboard-anonymous-avatar',
    VTO_SHOPPER: '/api/generate-vto/moodboard-shopper',
    ADD_TO_CART: '/api/add-to-cart',
    CURRENT_SUBSCRIPTION: '/api/domain={domain}/current-subscription',
  },
};

/**
 * Configuration API Mobile (Backend Django centralisé pour les shoppers)
 */
export const API_MOBILE_CONFIG = {
  // URL de base du backend api-appMobile
  BASE_URL: process.env.REACT_APP_API_MOBILE_URL || '',
};

/**
 * Configuration Signed URL Service (Cloud Run pour génération d'URLs signées GCS)
 */
export const SIGNED_URL_SERVICE_CONFIG = {
  // URL de base du service de génération d'URLs signées
  BASE_URL: process.env.REACT_APP_SIGNED_URL_SERVICE_URL || '',
};

/**
 * Configuration Face Detection Service (Cloud Run)
 */
export const FACE_DETECTION_CONFIG = {
  BASE_URL: process.env.REACT_APP_FACE_DETECTION_URL || '',
  ENDPOINT: '/detect-face',
};

/**
 * Messages et textes de l'application
 */
export const TEXTS = {
  APP_NAME: 'Mirror',
  INTRO_TITLE: 'Bienvenue chez Mirror',
  INTRO_DESCRIPTION: 'Découvrez comment vos vêtements vous iront grâce à notre technologie d\'essayage virtuel.',
};
